import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = () => {
    const { isAuthenticated,loading } = useAuth();
    if (loading) {
        return <div><h1>Loading...</h1></div>; // Ou un spinner de chargement
    }
   
    // Si pas connecté, redirection vers login
    // Sinon, affiche le contenu de la route (Outlet)
    
    return isAuthenticated ? <Outlet /> : <Navigate to="/connexion" replace />;
};

export default ProtectedRoute;
